import React, { createContext, useContext } from "react";
import { checkIsEmptyHtmlString } from "repoV2/utils/common/validators/validators";
import { useSalePageContext } from "../SalePageContext";

type IWhatYouWillDoSectionContextValue = {
    hide: boolean;
    title: string;
    description: string;
};

const initialContextValue: IWhatYouWillDoSectionContextValue = {
    hide: false,
    title: "",
    description: "",
};

const WhatYouWillDoSectionContext = createContext(initialContextValue);

export function WhatYouWillDoSectionContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { sectionsData, isPreview } = useSalePageContext();

    const title =
        sectionsData.whatYouWillDoSection.title ||
        (isPreview ? "&lt;What you'll do title&gt;" : "");
    const description =
        sectionsData.whatYouWillDoSection.description ||
        (isPreview ? "&lt;What you'll do description&gt;" : "");
    const contextValue: IWhatYouWillDoSectionContextValue = {
        hide:
            checkIsEmptyHtmlString(title) ||
            checkIsEmptyHtmlString(description),
        title,
        description,
    };
    return (
        <WhatYouWillDoSectionContext.Provider value={contextValue}>
            {children}
        </WhatYouWillDoSectionContext.Provider>
    );
}

export function useWhatYouWillDoSectionContext() {
    return useContext(WhatYouWillDoSectionContext);
}
